import { render, staticRenderFns } from "./DevicePairing.vue?vue&type=template&id=04f9a458&scoped=true"
import script from "./DevicePairing.vue?vue&type=script&lang=js"
export * from "./DevicePairing.vue?vue&type=script&lang=js"
import style0 from "./DevicePairing.vue?vue&type=style&index=0&id=04f9a458&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f9a458",
  null
  
)

export default component.exports